import { makeAutoObservable } from 'mobx'

import { localStorageService } from '@/service/storage.service'

class CustomerMessengerService {
  private isEnabled = true

  isActiveMessenger = false
  hasUnreadMessage = false

  constructor() {
    this.isEnabled = localStorageService.getItem('CUSTOMER_MESSENGER_VISIBILITY') ?? true
    makeAutoObservable(this)
  }

  get enabled() {
    return this.isEnabled
  }

  private setEnabled(
    isVisible: boolean,
    opt: { saveToStorage: boolean } = { saveToStorage: true },
  ) {
    this.isEnabled = isVisible
    if (opt.saveToStorage) {
      localStorageService.setItem('CUSTOMER_MESSENGER_VISIBILITY')(isVisible)
    }
  }

  enable(opt: { saveToStorage: boolean } = { saveToStorage: true }) {
    this.setEnabled(true, opt)
  }

  disable(opt: { saveToStorage: boolean } = { saveToStorage: true }) {
    this.setEnabled(false, opt)
  }

  toggleEnabled(opt: { saveToStorage: boolean } = { saveToStorage: true }) {
    this.setEnabled(!this.isEnabled, opt)
  }
}

export const customerMessengerService = new CustomerMessengerService()
